import internalApi from '@/utils/internalApi'
import Swal from 'sweetalert2'

export default class EmailRequest {
    #element
    #url

    constructor(element) {
        this.#element = element

        this.#url = element.getAttribute('data-url')
        if (this.#url === null) {
            throw new Error('Missing data-url attribute on element')
        }

        this.#bindEvents()
    }

    static initAll(selector) {
        Array.from(document.querySelectorAll(selector), (element) => new EmailRequest(element))
    }

    #bindEvents() {
        this.#element.addEventListener('click', this.#request)
    }

    #request = (event) => {
        event.preventDefault()

        internalApi
            .post(this.#url)
            .then(function (response) {
                console.log(response)
                Swal.fire({
                    icon: 'success',
                    title: response.data.data.attributes.type,
                    text: response.data.data.attributes.message,
                })
            })
            .catch(function (data) {
                Swal.fire({
                    icon: 'error',
                    title: data.response.data.errors[0].title,
                    text: data.response.data.errors[0].details,
                })
            })
    }
}
